export const logo = require('../assets/img/nead-logo.svg').default;